<template>
  <div>
    <div>
      <div v-if="calcularPagoLiquidacion">
        <exportLiquidacionVue
        :VerificacionSelect="VerificacionSelect"
        :sumaTotalVALOR="sumaTotalVALOR"
        :sumaTotalValorRegalados="totalRegalados"
        :DetalleVerificacion="DetalleVerificacion"
        :totalCobroVenta="totalCobroVenta"
        :sendPedido="sendPedido"
        :cantidadVerificaciones="cantidadVerificaciones"
        :desdeConfiguracion="2"
        @changeHandleUpdatePayments="changeHandleUpdatePayments"
        />
      </div>
    </div>
  </div>
</template>
<script>
import exportLiquidacionVue from '../../../../exportLiquidacion.vue'
import Generalmix from '../../../../../../../mixins/Generalmix';
export default{
  mixins:[Generalmix],
  components:{
    exportLiquidacionVue,
  },
  data() {
    return{
      sumaTotalVALOR:0,
      DetalleVerificacion:[],
      //REGALADOS
      totalRegalados:0,
      totalCobroVenta:0,
      arregloRegalados:[],
      arrayCombos:[],
      //VENTA REAL
      arregloValoresVentaReal:[],
      // sumaVentaReal:0,
      calcularPagoLiquidacion:false,
      mixinIdInicioFormatoNewData:null,
      arrayActasObsequios:[],
      datosVerificacion:'',
    }
  },
  props:{
    VerificacionSelect:{
      type:Object,
      default:function(){
        return {}
      }
    },
    sendPedido:{
      type:Object,
      default:function(){
        return {}
      }
    },
    cantidadVerificaciones:{
      type:Number,
      default:0,
    },
  },
  mounted(){
    let me = this;
    // Verifica si los datos existen en localStorage
    const mixinData = localStorage.getItem('mixin_IdInicioFormatoNew');
    if (mixinData) {
    // Convierte el JSON en un array de objetos y extrae solo 'minimo' si existe
    const parsedData = JSON.parse(mixinData);
    me.mixinIdInicioFormatoNewData = parsedData.length > 0 ? parsedData[0].minimo : null;
    console.log("Valor de minimo:", me.mixinIdInicioFormatoNewData); // Verifica el valor en consola
    } else {
        console.warn("No se encontraron datos en localStorage para mixin_IdInicioFormatoNew");
    }
    me.limpiar()
    me.getAllCodigosXContrato()
  },
  methods:{
    getAllCodigosXContrato(){
      let me = this;
      const { id_institucion ,id_periodo }              = me.sendPedido
      const { id, num_verificacion, contrato }          = me.VerificacionSelect
      // me.sumaVentaReal =0
      me.arregloValoresVentaReal = []
      // Acceder a la key 'pid' desde localStorage
      let pid = localStorage.getItem('pid');
      // Definir la rutaxperiodo en base al valor de pid
      let rutaxperiodo = '';
      if (pid <= me.mixinIdInicioFormatoNewData) {
          rutaxperiodo = this.$server_url + 'n_verificacion?contrato=' + contrato +
              '&getAllCodigosXContrato=yes&IdVerificacion=' + id +
              '&verificacion_id=' + num_verificacion +
              '&institucion_id=' + id_institucion +
              '&periodo_id=' + id_periodo +
              '&liquidados=1';
      } else if(pid > me.mixinIdInicioFormatoNewData) {
          rutaxperiodo = this.$server_url + 'n_verificacion?contrato=' + contrato +
              '&getAllCodigosXContrato_new=yes&IdVerificacion=' + id +
              '&verificacion_id=' + num_verificacion +
              '&institucion_id=' + id_institucion +
              '&periodo_id=' + id_periodo +
              '&liquidados=1';
      }
      me.$vs.loading();
      this.$http.get(rutaxperiodo)
      .then(function (res) {
        if(res.data.status == 0){
          me.m_message(res.data.message,'danger',5000)
          me.$vs.loading.close()
          return
        }
        
        me.arrayAllCodigos = res.data.filter(p => 
          (p.quitar_de_reporte != '1') && 
          ((p.combo == null || p.combo == '') || (p.codigo_combo == null || p.codigo_combo == '')) &&
          (p.tipo_codigo == '0')
        );
        //se obtiene los combos 
        me.arrayCombos = res.data.filter(p => p.tipo_codigo == '1')
        me.getVentaRealXVerificacion()
        me.getRegalados();
        me.getActasObsequios()
        me.$vs.loading.close();
        if(res.data.status == 0){
          me.$vs.notify({
            text:res.data.message,
            color:'danger',
            iconPack: 'feather',
            icon:'icon-alert-triangle'})
        }
      })
      .catch(function (error) {
          console.log(error + ' error');
          me.$vs.loading.close()
          me.$vs.notify({
            text:"Hubo un error al intentar cargar los datos",
            color:'danger',
            iconPack: 'feather',
            icon:'icon-alert-triangle'})
          return
      })
    },
    getActasObsequios(){
        let me = this;
        me.arrayActasObsequios = []
        me.datosVerificacion   = ''
        this.$http.get(this.$server_url+`pedidos2/pedidos?getLibrosObsequiosPedidos=1&id_pedido=${ me.sendPedido.id_pedido }&idVerificacion=${ me.VerificacionSelect.id }`)
        .then(res => {
          if(res.data.status == 0){
            me.$vs.notify({
            text:res.data.message,
            color:'danger',
            iconPack: 'feather',
            icon:'icon-check'})
            me.$vs.loading.close()
            return
          }
          me.arrayActasObsequios = res.data.actas
          me.datosVerificacion   = res.data.datosVerificacion
          me.getDetallesVerificacion()
        })
    },
    //aqui traigo codigos normales y codigos regalados
    getDetallesVerificacion(){
      let me = this;
      me.sumaTotalVALOR             = 0
      me.DetalleVerificacion        = []
      me.arrayCodigosVerificacion   = []
      const { id_institucion ,id_periodo }              = me.sendPedido
      const { id, num_verificacion, contrato }          = me.VerificacionSelect
      //AGRUPADO
      let datos                   = me.arrayAllCodigos.filter(p => (p.estado_liquidacion == '0' || p.estado_liquidacion == '2') && (p.bc_institucion == id_institucion || p.venta_lista_institucion == id_institucion) )
      me.arrayCodigosVerificacion = datos
      datos.forEach(item => {
        const nombre_libro    = item.nombre_libro;
        const codigo          = item.codigo;
        const precio          = item.precio;
        const libro_id        = item.libro_id;
        const IdVerificacion  = item.IdVerificacion;
        const verificacion_id = item.verificacion_id;
        const libro_idlibro   = item.libro_idlibro;
        // Busca si ya existe un objeto con el mismo libro en groupedData
        const existingGroup = me.DetalleVerificacion.find(group => group.nombre_libro === nombre_libro);
        // Si no existe, crea un nuevo objeto y agrégalo a groupedData
        if (!existingGroup) {
          me.DetalleVerificacion.push({ nombre_libro, codigo, precio, libro_id, IdVerificacion,verificacion_id, libro_idlibro ,cantidad: 1 });
        } else {
          // Si existe, incrementa la cantidad en el objeto existente
          existingGroup.cantidad++;
        }
      });
      me.DetalleVerificacion.map((item) => {
        item.valor        = item.precio * item.cantidad
        me.sumaTotalVALOR += item.valor
      });

      //OBSEQUIOS SI PERMISO_ACTA_OBSEQUIOS = 1
      if(me.datosVerificacion.permiso_acta_obsequios == 1){
        //sumar obsequios
        me.arrayActasObsequios.map((item) => {
          // Asegura que la cantidad sea un número entero (sin redondear, truncando la parte decimal)
          item.cantidad = parseInt(item.cantidad);  
          console.log("Cantidad de obsequios:", item.cantidad);

          // Calcula el valorOriginal de cada item (sin descuento)
          item.valorOriginal = item.precio * item.cantidad;
          console.log("Valor original de obsequios:", item.valorOriginal);

          // Asegúrate de que ven_desc_por sea un número y que tenga un valor válido
          if (isNaN(item.ven_desc_por)) {
            console.log("Advertencia: 'ven_desc_por' no es un número válido.");
            item.ven_desc_por = 0; // Asignar un valor por defecto si no es válido
          }
          
          // Aplica el descuento
          const descuento = item.valorOriginal * (item.ven_desc_por / 100);
          console.log("Descuento aplicado:", descuento);

          // Resta el descuento al valorOriginal total del item
          item.valor = item.valorOriginal - descuento;
          console.log("Valor con descuento de obsequios:", item.valor);  // Usa 'item.valor' en lugar de 'item.valorConDescuento'

          // Suma el valor con descuento al total
          me.sumaTotalVALOR += item.valor;

          // Verifica que la suma total esté correcta
          console.log("Suma total con descuento:", me.sumaTotalVALOR);
        });
        me.DetalleVerificacion = [...me.DetalleVerificacion,...me.arrayActasObsequios]
      }

      //agregar cantidad igual a la propiedad cantidad_items en el arrayCombos
      me.arrayCombos.map((item) => {
        item.cantidad = item.cantidad_items
      });
      //unir arrayCombos  a DetalleVerificacion
      me.DetalleVerificacion = [...me.DetalleVerificacion,...me.arrayCombos]
      //sumar combos
      me.arrayCombos.map((item) => {
        item.valor        = item.precio * item.cantidad_items
        me.sumaTotalVALOR += item.valor
      });
      me.updateValorLiquidacion()
    },
    getVentaRealXVerificacion(){
      let me = this;
      const { id_institucion ,id_periodo }              = me.sendPedido
      const { id, num_verificacion, contrato }          = me.VerificacionSelect
      //si no hay codigos no hace nada
      if(me.arrayAllCodigos.length == 0){ me.f_sumarCombos(); return }
      // me.sumaVentaReal            = 0
      me.arregloValoresVentaReal  = []
      let datos                   = me.arrayAllCodigos.filter(p => p.estado_liquidacion == '0' && p.bc_institucion == id_institucion && p.estado != '2' && p.contrato == contrato)
      // Itera a través de los elementos del array
      datos.forEach(item => {
        const nombre_libro    = item.nombre_libro;
        const codigo          = item.codigo;
        const precio          = item.precio;
        const libro_id        = item.libro_id;
        const IdVerificacion  = item.IdVerificacion;
        const verificacion_id = item.verificacion_id;
        const libro_idlibro   = item.libro_idlibro;
        // Busca si ya existe un objeto con el mismo libro en groupedData
        const existingGroup = me.arregloValoresVentaReal.find(group => group.nombre_libro === nombre_libro);
        // Si no existe, crea un nuevo objeto y agrégalo a groupedData
        if (!existingGroup) {
          me.arregloValoresVentaReal.push({ nombre_libro, codigo, precio, libro_id, IdVerificacion, verificacion_id, libro_idlibro, cantidad: 1 });
        } else {
          // Si existe, incrementa la cantidad en el objeto existente
          existingGroup.cantidad++;
        }
      });
      // me.arregloValoresVentaReal.map((item) => {
      //   item.valor = item.precio * item.cantidad
      //   me.sumaVentaReal += item.valor
      // });
      //sumar combos
      // me.f_sumarCombos()
    },
    // f_sumarCombos(){
    //   let me = this
    //   me.arrayCombos.map((item) => {
    //     item.valor = item.precio * item.cantidad_items
    //     me.sumaVentaReal += item.valor
    //   });
    // },  
    getRegalados(){
      let me = this
      me.totalRegalados = 0
      me.totalCobroVenta = 0
      me.arregloRegalados = []
      const { id_institucion ,id_periodo, descuento }                      = me.sendPedido
      const { id, num_verificacion,tipoPago,permiso_cobro_venta_directa }  = me.VerificacionSelect
        //AGRUPADO
        let datos                   = me.arrayAllCodigos.filter(p => (p.estado_liquidacion == '2') && (p.bc_institucion == id_institucion || p.venta_lista_institucion == id_institucion) )
      datos.forEach(item => {
        const nombre_libro    = item.nombre_libro;
        const codigo          = item.codigo;
        const precio          = item.precio;
        const libro_id        = item.libro_id;
        const IdVerificacion  = item.IdVerificacion;
        const verificacion_id = item.verificacion_id;
        const libro_idlibro   = item.libro_idlibro;
        // Busca si ya existe un objeto con el mismo libro en groupedData
        const existingGroup = me.arregloRegalados.find(group => group.nombre_libro === nombre_libro);
        // Si no existe, crea un nuevo objeto y agrégalo a groupedData
        if (!existingGroup) {
          me.arregloRegalados.push({ nombre_libro, codigo, precio, libro_id, IdVerificacion,verificacion_id, libro_idlibro, cantidad: 1  });
        } else {
          // Si existe, incrementa la cantidad en el objeto existente
          existingGroup.cantidad++;
        }
      });
      me.arregloRegalados.map((item) => {
        item.valor        = item.precio * item.cantidad
        me.totalRegalados += item.valor
      });
      if(me.arregloRegalados.length > 0){
          let prevalor        = 0
          //COBRO VENTA DIRECTA=>0 = NADA; 1 = 100%; 2 =porcentaje de la escuela;
          //tipoPago => 0 =  NADA; 1 = Cancelar Total; 2 = Descontar; 3 = Regalado = 4 personalizado
          if(tipoPago == 1 || tipoPago == 3) { me.totalCobroVenta = 0 }
          if(tipoPago == 2 || me.setPersonalizado == 1) {
            prevalor = descuento
            //si el cobro de venta directa esta activado
            if(permiso_cobro_venta_directa == 1){
              me.totalCobroVenta  = ( me.totalRegalados - ( me.totalRegalados * prevalor ) / 100)
            }else{
              me.totalCobroVenta = 0
            }
          }
        }
    },
   
    updateValorLiquidacion(){
      let me = this;
      let formData = new FormData();
      formData.append('verificacion_id',    me.VerificacionSelect.id);
      // formData.append('venta_real',         me.sumaTotalVALOR + me.totalRegalados);
      formData.append('venta_real',         me.sumaTotalVALOR);
      formData.append('venta_real_regalados',me.totalRegalados)
      this.$http.post(this.$server_url+'updateVentaReal', formData)
      .then(res => {
        //Calcular los valores
        me.calcularPagoLiquidacion = true
      })
    },
    changeHandleUpdatePayments(e){
      let me = this
      me.changeHandleUpdatePayments       = false
      me.limpiar()
      me.$emit('changeHandleUpdatePayments',true)
    },
    limpiar(){
      let me = this
      me.sumaTotalVALOR           = 0
      me.DetalleVerificacion      = []
      //REGALADOS
      me.totalRegalados           = 0
      me.totalCobroVenta          = 0
      me.arregloRegalados         = []
      //VENTA REAL
      me.arregloValoresVentaReal  = []
      // me.sumaVentaReal            = 0
      me.calcularPagoLiquidacion  = false
      //CONVENIO
      me.arregloHijosConvenio     = []
      me.NumeroConvenio           = 0
      me.ObjectConvenio           = {}
      me.SaldoConvenio            = 0
      me.totalAnticipos           = 0
    },
  }
}
</script>
